export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39')
];

export const server_loads = [0,2,3,6,4];

export const dictionary = {
		"/(marketing)": [26,[5]],
		"/(app)/(admin)/analytics": [8,[2,3]],
		"/(marketing)/(auth)/auth/error": [~27,[5,6]],
		"/(marketing)/blog": [~32,[5,7]],
		"/(marketing)/blog/[slug]": [~33,[5,7]],
		"/checkout/upgrade/[priceId]": [~39],
		"/checkout/[priceID]": [~38],
		"/(marketing)/contact": [~34,[5]],
		"/(app)/customers-management": [9,[2]],
		"/(app)/dashboard": [~10,[2]],
		"/(marketing)/(auth)/forgot-password": [~28,[5,6]],
		"/(marketing)/guida": [35,[5]],
		"/(marketing)/guida/[slug]": [36,[5]],
		"/(app)/log-out": [11,[2]],
		"/(marketing)/(auth)/login": [~29,[5,6]],
		"/(app)/news": [12,[2]],
		"/(app)/not-allowed": [~13,[2]],
		"/(marketing)/privacy-policy": [37,[5]],
		"/(marketing)/(auth)/register": [~30,[5,6]],
		"/(marketing)/(auth)/security-error": [31,[5,6]],
		"/(app)/services-management": [14,[2]],
		"/(app)/settings": [~15,[2,4]],
		"/(app)/settings/billing": [~16,[2,4]],
		"/(app)/settings/billing/manage": [~17,[2,4]],
		"/(app)/settings/profile": [~18,[2,4]],
		"/(app)/settings/security": [~19,[2,4]],
		"/(app)/team-setup": [~22,[2]],
		"/(app)/team": [~20,[2]],
		"/(app)/team/[slug]": [~21,[2]],
		"/(app)/trial-ended": [~23,[2]],
		"/(app)/upgrade-plan": [~24,[2]],
		"/(app)/working-hours": [~25,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';